import { ServiceRequest } from "../models/Service";

export enum ServiceRequestActionDispatchType {
  GET_SERVICE_REQUEST_INVOKE = "GET_SERVICE_REQUEST_INVOKE",
  GET_SERVICE_REQUEST_SUCCESS = "GET_SERVICE_REQUEST_SUCCESS",
  GET_SERVICE_REQUEST_RESET = "GET_SERVICE_REQUEST_RESET",

  POST_PUT_SERVICE_REQUEST_ERROR = "POST_PUT_SERVICE_REQUEST_ERROR",
  POST_PUT_SERVICE_REQUEST_INVOKE = "POST_PUT_SERVICE_REQUEST_INVOKE",
  POST_PUT_SERVICE_REQUEST_SUCCESS = "POST_PUT_SERVICE_REQUEST_SUCCESS",
  POST_PUT_SERVICE_REQUEST_RESET = "POST_PUT_SERVICE_REQUEST_RESET",
}

export const ServiceRequestInitialValues: ServiceRequest = {
  diseasesDto: [],
  psychologicalDiseasesDto: [],
  referralCareTypeDto: [],
  referralDisciplineDto: [],
  referralId: null,
  startOfCareDate: null,
  userCreated: null,
  currentEndDate: null,
  currentStartDate: null,
  userId: null
};

export enum ServiceProviderActionDispatchType {
  GET_SERVICE_PROVIDER_DETAIL_INVOKE = "GET_SERVICE_PROVIDER_DETAIL_INVOKE",
  GET_SERVICE_PROVIDER_DETAIL_SUCCESS = "GET_SERVICE_PROVIDER_DETAIL_SUCCESS",
  GET_SERVICE_PROVIDER_DETAIL_RESET = "GET_SERVICE_PROVIDER_DETAIL_RESET",

  POST_PUT_SERVICE_PROVIDER_SUCCESS = "POST_PUT_SERVICE_PROVIDER_SUCCESS",
  POST_PUT_SERVICE_PROVIDER_INVOKE = "POST_PUT_SERVICE_PROVIDER_INVOKE",
  POST_PUT_SERVICE_PROVIDER_ERROR = "POST_PUT_SERVICE_PROVIDER_ERROR",
  POST_PUT_SERVICE_PROVIDER_RESET = "POST_PUT_SERVICE_PROVIDER_RESET",

  GET_SERVICE_PROVIDER_LIST_INVOKE = "GET_SERVICE_PROVIDER_LIST_INVOKE",
  GET_SERVICE_PROVIDER_LIST_SUCCESS = "GET_SERVICE_PROVIDER_LIST_SUCCESS",
  GET_SERVICE_PROVIDER_LIST_RESET = "GET_SERVICE_PROVIDER_LIST_RESET",
}
export enum ServiceProviderMasterActionDispatchType {
  SERVICE_PROVIDER_MASTER_SUCCESS = "SERVICE_PROVIDER_MASTER_SUCCESS",
  SERVICE_PROVIDER_MASTER_INVOKE = "SERVICE_PROVIDER_MASTER_INVOKE",
  SERVICE_PROVIDER_MASTER_RESET = "SERVICE_PROVIDER_MASTER_RESET",
}
export enum FacilityTypeMasterActionDispatchType {
  FACILITY_TYPE_MASTER_BY_TEXT_SUCCESS = "FACILITY_TYPE_MASTER_BY_TEXT_SUCCESS",
  FACILITY_TYPE_MASTER_BY_TEXT_INVOKE = "FACILITY_TYPE_MASTER_BY_TEXT_INVOKE",
  FACILITY_TYPE_MASTER_BY_TEXT_RESET = "FACILITY_TYPE_MASTER_BY_TEXT_RESET"
}
export enum PatientStateActionDispatchType {
  PATIENT_STATE_SUCCESS = "PATIENT_STATE_SUCCESS",
  PATIENT_STATE_INVOKE = "PATIENT_STATE_INVOKE",
}

export enum CountyActionDispatchType {
  GET_COUNTY_SUCCESS = "GET_COUNTY_SUCCESS",
  GET_COUNTY_INVOKE = "GET_COUNTY_INVOKE"
}

export const ServiceProviderAddress = {
  streetName1: null,
  streetName2: null,
  providerCity: null,
  providerCounty: null,
  providerState: null,
  zipCode: null,
};

export const ServiceProviderDefaultValues = {
  referralId: 0,
  referralServiceProviderId: 0,
  serviceProviderId: null,
  providerName: "",
  providerNpi: "",
  providerId: 0,
  plexisOfficeId: 0,
  userCreated: null,
  ...ServiceProviderAddress,
};

export enum ReAuthServiceRequestActionDispatchType {
  RE_AUTH_SERVICE_REQUEST_SUCCESS = "RE_AUTH_SERVICE_REQUEST_SUCCESS",
  RE_AUTH_SERVICE_REQUEST_INVOKE = "RE_AUTH_SERVICE_REQUEST_INVOKE",
  RE_AUTH_SERVICE_REQUEST_ERROR = "RE_AUTH_SERVICE_REQUEST_ERROR",
  RE_AUTH_SERVICE_REQUEST_RESET = "RE_AUTH_SERVICE_REQUEST_RESET",

  RE_AUTH_SERVICE_REQUEST_POST_SUCCESS = "RE_AUTH_SERVICE_REQUEST_POST_SUCCESS",
  RE_AUTH_SERVICE_REQUEST_POST_INVOKE = "RE_AUTH_SERVICE_REQUEST_POST_INVOKE",

  RE_AUTH_SERVICE_REQUEST_PUT_SUCCESS = "RE_AUTH_SERVICE_REQUEST_PUT_SUCCESS",
  RE_AUTH_SERVICE_REQUEST_PUT_INVOKE = "RE_AUTH_SERVICE_REQUEST_PUT_INVOKE",
}

export enum AuthVisitTypes {
  CURRENT_AUTH_REQUESTED_VISITS = "currentAuthRequestedVisits",
  NEXT_AUTH_REQUESTED_VISITS = "nextAuthRequestedVisits",
}

export enum AllowedVisitCounts {
  MAX = 9999,
  MIN = 0,
}

export enum DisciplineTableHeader {
  SELECT = "Select",
  DISCIPLINES = "Disciplines",
  REQUESTED_NO_OF_VISITS = "Requested no. of visits",
  TOTAL = "TOTAL:",
}

export enum OutOfNetworkProvider{
  BENEFIT_PLAN_ALLOW_OON = "An Out-of-Network provider has been selected for this member. Confirm that this Out-of-Network placement is approved.",
  BENEFIT_PLAN_NOT_ALLOW_OON ="This member does not have Out-of-Network benefits. Have you been approved to choose this Out-of-Network Provider for this authorization?"
}

export enum isRetroServiceStatus {
    IS_RETRO_HEADER = "The start of Care Date given is in the past more than one business day. Please provide the number of visits by requested discipline that fall within the dates below."
}